/* eslint-disable @typescript-eslint/camelcase */
import { LocaleHelper } from '@skbkontur/react-ui/lib/locale/LocaleHelper';
import { componentsLocales as en_GB } from './locales/en';
import { componentsLocales as ru_RU } from './locales/ru';
export var TopBarLocaleHelper = new LocaleHelper({
  ru_RU: ru_RU,
  en_GB: en_GB
});